import type { GeoJSON } from "geojson";

/** A single evidence row attached to a record geo-item (reference + optional citation page). */
export interface RecordGeoItemEvidence {
  id?: string;
  reference: { id: string; title: string } | null;
  citation?: { page?: string };
}

/**
 * Create/edit form for a record geo-item. `h3Indexes` + `geometry` are driven by
 * the EditMap (one or the other carries the drawn area); the rest are form fields.
 */
export interface RecordGeoItemFormData {
  date: string;
  endDate: string;
  jaLabel: string | null;
  enLabel: string | null;
  h3Indexes: string[];
  geometry: GeoJSON | null;
  memo: string | null;
  evidences: RecordGeoItemEvidence[];
}

/** Empty defaults for the create form. */
export const emptyRecordGeoItemForm: RecordGeoItemFormData = {
  date: "",
  endDate: "",
  jaLabel: "",
  enLabel: "",
  h3Indexes: [],
  geometry: null,
  memo: "",
  // Seed one empty evidence row (V1 parity); at least one evidence is required on submit.
  evidences: [{ reference: null, citation: { page: "" } }],
};
